// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime"
import { Spinner } from "../../Spinner"

const TableWrapper = ({
  data,
  isLoading,
  children,
  msg = "No se han encontrado registros"
}: any) => {
  if (isLoading) {
    return _jsx(
      "div",
      {
        className: "text-center",
        children: _jsx(
          Spinner,
          { loading: !!isLoading, color: "rgb(54, 215, 183)" },
          void 0
        ),
      },
      void 0
    )
  }
  if (Array.isArray(data)) {
    return children
  }
  return _jsx(
    "div",
    {
      className: "text-center",
      children: _jsx("h3", { children: msg }, void 0),
    },
    void 0
  )
}
export default TableWrapper
